import React, { useEffect, useState } from "react"
import styles from "./ProjectList.module.css"
import { AIProject } from "../Model/types"
import { useNavigate } from "react-router-dom"
import SignOut from "../../Components/SignOut"

export interface ProjectListProps {
    projects: AIProject[]
    selectProject: (project: AIProject) => void
}

const ProjectList: React.FC<ProjectListProps> = ({ projects, selectProject }) => {
    useEffect(() => {}, [])

    const projectRows = projects.map((project) => {
        return (
            <div key={project.id} className={styles.projectRow} onClick={() => selectProject(project)}>
                <div className={styles.rowTitle}>{project.name}</div>
            </div>
        )
    })

    return (
        <div className={styles.projectList}>
            <div className={styles.title}>AI CoE Projects</div>
            <div className={styles.projectRows}>{projectRows}</div>
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <SignOut />
            </div>
        </div>
    )
}

export default ProjectList
